import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LogoComponent } from "../logo/logo.component";
import { SocialsComponent } from "../socials/socials.component";
import { ScaricaAppComponent } from "../scarica-app/scarica-app.component";

@Component({
  selector: 'app-footer',
  imports: [CommonModule, LogoComponent, SocialsComponent, ScaricaAppComponent],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent implements OnInit {
  currentYear: number = new Date().getFullYear();

  tipologia: string = '';
  isLandingPage: boolean = false;
  currentLink: string = '';
  isLandingWithType: boolean = false;

  constructor(
    private route: ActivatedRoute,
    public router: Router,
  ) {}

  ngOnInit() {


  }
}

